<template>
  <v-img
    class="avatar"
    :src="img ? apiDomain + '/min/' + img : require('@/assets/svg/ImageNotFound.svg')"
    :height="size"
    :width="size"
    alt=""
  >
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate color="#277faf"></v-progress-circular>
      </v-row>
    </template>
  </v-img>
</template>

<script>
export default {
  name: 'UserPhoto',
  props: ['size', 'img', 'textFirst', 'textSecond'],
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  border-radius: 50%;
  &.noPhoto {
    background-color: #277faf;
    // grid-template-rows: 30% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 2%;
    justify-content: center;
    justify-items: center;
    position: relative;

    .initials {
      font-weight: bold;
      line-height: 1;
      color: #ffffff;
    }
    .icon {
      width: auto;
      height: 30%;
    }
  }
}
</style>
